import React, { useEffect, useState } from "react";
import {
  formatDate,
  formatPhoneNumber,
  formatTime,
  secondsToMinutes,
  backgroundColor,
} from "../../functions/util/format";
import {
  BsPlayFill,
  BsStopFill,
  BsDownload,
  BsCloudArrowDown,
} from "react-icons/bs";
import { MdArchive, MdUnarchive } from "react-icons/md";
import Sound from "react-sound";
import serverUrl from "../../constants/serverUrl";
import ArchiveCommModal from "../modals/ArchiveCommModal";
import fileDownload from "js-file-download";
import { updateVoicemail } from "../../functions/office/commRecords";

const Voicemail = ({ voicemail, reload, users }) => {
  //the react-sound pkg prints authToken to console without the debugMode turned off.
  //aka keep this line it is very important
  window.soundManager.setup({ debugMode: false });
  /////
  const [formattedDate, setFormattedDate] = useState("");
  const [formattedTo, setFormattedTo] = useState("");
  const [formattedFrom, setFormattedFrom] = useState("");
  const [formattedTime, setFormattedTime] = useState("");
  const [formattedDuration, setFormattedDuration] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const [recordingLink, setRecordingLink] = useState("");
  const [archiveCommModal, setArchiveCommModal] = useState(false);
  const [color, setColor] = useState("");
  const [link, setLink] = useState("");
  const [tag, setTag] = useState(voicemail.tag); // Add state for tag
  const [assignment, setAssignment] = useState(voicemail.assignedTo); // Add state for tag

  useEffect(() => {
    setTag(voicemail.tag); // Sync state with initial voicemail tag
    setAssignment(voicemail.assignedTo);
  }, [voicemail.assignedTo, voicemail.tag]);

  useEffect(() => {
    const formatting = async () => {
      const color = await backgroundColor(
        voicemail.flag,
        "voicemail",
        voicemail.isArchived
      );
      setColor(color);
      const date = await formatDate(voicemail.recordingStart);
      setFormattedDate(date);
      const fromNumber = await formatPhoneNumber(voicemail.from);
      setFormattedFrom(fromNumber);
      const toNumber = await formatPhoneNumber(voicemail.to);
      setFormattedTo(toNumber);
      const time = await formatTime(voicemail.recordingStart);
      setFormattedTime(time);
      const vmDuration = await secondsToMinutes(voicemail.recordingDuration);
      setFormattedDuration(vmDuration);
    };
    formatting();
  }, []);

  const updateTag = async (newTag) => {
    updateVoicemail(voicemail._id, { tag: newTag });
    setTag(newTag);
  };

  const updateAssignment = async (assignedTo) => {
    updateVoicemail(voicemail._id, { assignedTo });
    setAssignment({ _id: assignedTo });
  };

  const handlePlay = async (serverUrl) => {
    setIsPlaying(!isPlaying);
    const twilioUrl = await encodeURI(voicemail.recordingUrl);
    let authToken = await localStorage.getItem("authToken");
    // removes quotations from authToken string
    authToken = authToken.replace(/"/g, "");
    const recordingLink =
      serverUrl + "/recording?twilioUrl=" + twilioUrl + "&token=" + authToken;
    setRecordingLink(recordingLink);
  };

  const handleDownload = async () => {
    const twilioUrl = await encodeURI(voicemail.recordingUrl);
    let authToken = await localStorage.getItem("authToken");
    // removes quotations from authToken string
    authToken = authToken.replace(/"/g, "");
    const recordingLink =
      serverUrl + "/recording?twilioUrl=" + twilioUrl + "&token=" + authToken;

    fetch(recordingLink)
      .then((response) => response.blob())
      .then((blobData) => {
        // Use fileDownload to save the blob data
        fileDownload(
          blobData,
          `${formattedDate} ${voicemail.from}  ${voicemail.to} recording.wav`
        );
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  return (
    <>
      <tr style={{ backgroundColor: color }}>
        <td className="table-item">{formattedDate}</td>
        <td className="table-item">{formattedTime}</td>
        <td className="table-item">{formattedFrom}</td>
        <td className="table-item">{formattedTo}</td>
        <td className="table-item">{formattedDuration}</td>
        <td className="table-icon-container">
          {isPlaying ? (
            <BsStopFill
              className="table-icon"
              color="#219ebc"
              size={35}
              onClick={() => setIsPlaying(false)}
            />
          ) : (
            <BsPlayFill
              className="table-icon"
              color="#219ebc"
              size={35}
              onClick={() => handlePlay(serverUrl)}
            />
          )}
          <Sound
            url={recordingLink}
            playStatus={isPlaying ? Sound.status.PLAYING : Sound.status.STOPPED}
            onFinishedPlaying={() => setIsPlaying(false)}
          />
          <BsCloudArrowDown
            className="table-icon"
            color="#000"
            size={25}
            onClick={handleDownload}
          />
        </td>
        <td className="table-icon-container">
          {voicemail.isArchived === true ? (
            <MdUnarchive
              className="table-icon"
              color="#adadad"
              size={35}
              onClick={() => setArchiveCommModal(true)}
              title="Unarchive"
            ></MdUnarchive>
          ) : (
            <MdArchive
              className="table-icon"
              color="#fb8500"
              size={35}
              onClick={() => setArchiveCommModal(true)}
              title="Archive"
            />
          )}
          {archiveCommModal && (
            <ArchiveCommModal
              setArchiveCommModal={setArchiveCommModal}
              isArchived={voicemail.isArchived}
              data={voicemail}
              reload={reload}
            />
          )}
        </td>
      </tr>
      <tr className="border-b-8 border-white bg-gray-100">
        <td colSpan={7} className="px-6 py-4">
          <div className="flex flex-row gap-6 text-gray-200">
            {/* Status */}
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-gray-900">Status:</span>
              {voicemail.returned && (
                <span className="rounded-full bg-green-600/80 px-3 py-1 text-sm font-semibold uppercase text-white shadow-sm">
                  Returned
                </span>
              )}

              {!voicemail.returned && (
                <span
                  className={
                    "rounded-full " +
                    (voicemail.readBy ? "bg-blue-600/80" : "bg-red-600/80") +
                    " px-3 py-1 text-sm font-semibold uppercase text-white shadow-sm"
                  }
                >
                  {voicemail.readBy ? "Read" : "Unread"}
                </span>
              )}
            </div>

            {/* Tag */}
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-gray-900">Tag:</span>
              <select
                className="rounded-lg border border-gray-600 bg-gray-300 px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500/30"
                value={tag} // Use the state variable
                onChange={(e) => updateTag(e.target.value)} // Trigger updateTag on change
              >
                <option value="">Select Tag</option>
                <option value="wrong-number">Wrong Number</option>
                <option value="spam">Spam</option>
                <option value="robocall">RoboCall</option>
                <option value="personal">Personal</option>
                <option value="silent">Silent</option>
                <option value="duplicate">Duplicate</option>
                <option value="out-of-scope">Out-of-Scope</option>
                <option value="needs-review">Needs Review</option>
                <option value="pending">Pending</option>
                <option value="call-back">Call Back</option>
                <option value="resolved">Resolved</option>
              </select>
            </div>

            {/* Read By */}
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-gray-900">
                Read By:
              </span>
              <span className="rounded-md bg-gray-200 px-3 py-1 text-sm font-semibold text-black">
                {voicemail.readBy
                  ? `${voicemail.readBy.firstName} ${voicemail.readBy.lastName}`
                  : "N/A"}
              </span>
            </div>

            {/* Assigned To */}
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-gray-900">
                Assigned To:
              </span>
              <select
                className="rounded-lg border border-gray-600 bg-gray-300 px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500/30"
                value={assignment ? assignment._id : ""}
                onChange={(event) => updateAssignment(event.target.value)}
              >
                <option value="">Select Assignment</option>
                {users.map((as) => (
                  <option value={as._id}>
                    {`${as.firstName} ${as.lastName}`}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </td>
      </tr>
    </>
  );
};

export default Voicemail;
